// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class ForgeProjectContext {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a;
        this.id = model.id;
        this.workspaceId = model.workspaceId;
        this.designSystemId = model.designSystemId;
        this.name = model.name;
        this.description = model.description;
        this.productContext = model.productContext;
        this.componentSet = model.componentSet;
        this.iconSet = model.iconSet;
        this.additionalContext = model.additionalContext;
        this.theme = model.theme;
        this.createdAt = new Date(model.createdAt);
        this.updatedAt = new Date(model.updatedAt);
        this.isArchived = model.isArchived;
        this.themePreset = model.themePreset;
        this.defaultTokenThemeSetId = model.defaultTokenThemeSetId;
        this.tokenThemeSets = (_a = model.tokenThemeSets) !== null && _a !== void 0 ? _a : [];
        this.brandId = model.brandId;
        this.sandboxTemplate = model.sandboxTemplate;
    }
    toRemote() {
        return this;
    }
}
